let mockFollowers = [
  {
    login: 'tarasis',
    id: 3006,
    node_id: 'MDQ6VXNlcjMwMDY=',
    avatar_url: 'https://avatars.githubusercontent.com/u/3006?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/tarasis',
    html_url: 'https://github.com/tarasis',
    followers_url: 'https://api.github.com/users/tarasis/followers',
    following_url:
      'https://api.github.com/users/tarasis/following{/other_user}',
    gists_url: 'https://api.github.com/users/tarasis/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/tarasis/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/tarasis/subscriptions',
    organizations_url: 'https://api.github.com/users/tarasis/orgs',
    repos_url: 'https://api.github.com/users/tarasis/repos',
    events_url: 'https://api.github.com/users/tarasis/events{/privacy}',
    received_events_url: 'https://api.github.com/users/tarasis/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'benackles',
    id: 12502,
    node_id: 'MDQ6VXNlcjEyNTAy',
    avatar_url: 'https://avatars.githubusercontent.com/u/12502?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/benackles',
    html_url: 'https://github.com/benackles',
    followers_url: 'https://api.github.com/users/benackles/followers',
    following_url:
      'https://api.github.com/users/benackles/following{/other_user}',
    gists_url: 'https://api.github.com/users/benackles/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/benackles/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/benackles/subscriptions',
    organizations_url: 'https://api.github.com/users/benackles/orgs',
    repos_url: 'https://api.github.com/users/benackles/repos',
    events_url: 'https://api.github.com/users/benackles/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/benackles/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'jagdpenta',
    id: 25173,
    node_id: 'MDQ6VXNlcjI1MTcz',
    avatar_url: 'https://avatars.githubusercontent.com/u/25173?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/jagdpenta',
    html_url: 'https://github.com/jagdpenta',
    followers_url: 'https://api.github.com/users/jagdpenta/followers',
    following_url:
      'https://api.github.com/users/jagdpenta/following{/other_user}',
    gists_url: 'https://api.github.com/users/jagdpenta/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/jagdpenta/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/jagdpenta/subscriptions',
    organizations_url: 'https://api.github.com/users/jagdpenta/orgs',
    repos_url: 'https://api.github.com/users/jagdpenta/repos',
    events_url: 'https://api.github.com/users/jagdpenta/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/jagdpenta/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'elvan',
    id: 35147,
    node_id: 'MDQ6VXNlcjM1MTQ3',
    avatar_url: 'https://avatars.githubusercontent.com/u/35147?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/elvan',
    html_url: 'https://github.com/elvan',
    followers_url: 'https://api.github.com/users/elvan/followers',
    following_url: 'https://api.github.com/users/elvan/following{/other_user}',
    gists_url: 'https://api.github.com/users/elvan/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/elvan/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/elvan/subscriptions',
    organizations_url: 'https://api.github.com/users/elvan/orgs',
    repos_url: 'https://api.github.com/users/elvan/repos',
    events_url: 'https://api.github.com/users/elvan/events{/privacy}',
    received_events_url: 'https://api.github.com/users/elvan/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'taosapp',
    id: 36772,
    node_id: 'MDQ6VXNlcjM2Nzcy',
    avatar_url: 'https://avatars.githubusercontent.com/u/36772?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/taosapp',
    html_url: 'https://github.com/taosapp',
    followers_url: 'https://api.github.com/users/taosapp/followers',
    following_url:
      'https://api.github.com/users/taosapp/following{/other_user}',
    gists_url: 'https://api.github.com/users/taosapp/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/taosapp/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/taosapp/subscriptions',
    organizations_url: 'https://api.github.com/users/taosapp/orgs',
    repos_url: 'https://api.github.com/users/taosapp/repos',
    events_url: 'https://api.github.com/users/taosapp/events{/privacy}',
    received_events_url: 'https://api.github.com/users/taosapp/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'cksachdev',
    id: 37770,
    node_id: 'MDQ6VXNlcjM3Nzcw',
    avatar_url: 'https://avatars.githubusercontent.com/u/37770?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/cksachdev',
    html_url: 'https://github.com/cksachdev',
    followers_url: 'https://api.github.com/users/cksachdev/followers',
    following_url:
      'https://api.github.com/users/cksachdev/following{/other_user}',
    gists_url: 'https://api.github.com/users/cksachdev/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/cksachdev/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/cksachdev/subscriptions',
    organizations_url: 'https://api.github.com/users/cksachdev/orgs',
    repos_url: 'https://api.github.com/users/cksachdev/repos',
    events_url: 'https://api.github.com/users/cksachdev/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/cksachdev/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'undencem',
    id: 40747,
    node_id: 'MDQ6VXNlcjQwNzQ3',
    avatar_url: 'https://avatars.githubusercontent.com/u/40747?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/undencem',
    html_url: 'https://github.com/undencem',
    followers_url: 'https://api.github.com/users/undencem/followers',
    following_url:
      'https://api.github.com/users/undencem/following{/other_user}',
    gists_url: 'https://api.github.com/users/undencem/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/undencem/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/undencem/subscriptions',
    organizations_url: 'https://api.github.com/users/undencem/orgs',
    repos_url: 'https://api.github.com/users/undencem/repos',
    events_url: 'https://api.github.com/users/undencem/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/undencem/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'pauloesantos',
    id: 46524,
    node_id: 'MDQ6VXNlcjQ2NTI0',
    avatar_url: 'https://avatars.githubusercontent.com/u/46524?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/pauloesantos',
    html_url: 'https://github.com/pauloesantos',
    followers_url: 'https://api.github.com/users/pauloesantos/followers',
    following_url:
      'https://api.github.com/users/pauloesantos/following{/other_user}',
    gists_url: 'https://api.github.com/users/pauloesantos/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/pauloesantos/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/pauloesantos/subscriptions',
    organizations_url: 'https://api.github.com/users/pauloesantos/orgs',
    repos_url: 'https://api.github.com/users/pauloesantos/repos',
    events_url: 'https://api.github.com/users/pauloesantos/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/pauloesantos/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'arthu',
    id: 55780,
    node_id: 'MDQ6VXNlcjU1Nzgw',
    avatar_url: 'https://avatars.githubusercontent.com/u/55780?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/arthu',
    html_url: 'https://github.com/arthu',
    followers_url: 'https://api.github.com/users/arthu/followers',
    following_url: 'https://api.github.com/users/arthu/following{/other_user}',
    gists_url: 'https://api.github.com/users/arthu/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/arthu/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/arthu/subscriptions',
    organizations_url: 'https://api.github.com/users/arthu/orgs',
    repos_url: 'https://api.github.com/users/arthu/repos',
    events_url: 'https://api.github.com/users/arthu/events{/privacy}',
    received_events_url: 'https://api.github.com/users/arthu/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'wxqfree',
    id: 57497,
    node_id: 'MDQ6VXNlcjU3NDk3',
    avatar_url: 'https://avatars.githubusercontent.com/u/57497?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/wxqfree',
    html_url: 'https://github.com/wxqfree',
    followers_url: 'https://api.github.com/users/wxqfree/followers',
    following_url:
      'https://api.github.com/users/wxqfree/following{/other_user}',
    gists_url: 'https://api.github.com/users/wxqfree/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/wxqfree/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/wxqfree/subscriptions',
    organizations_url: 'https://api.github.com/users/wxqfree/orgs',
    repos_url: 'https://api.github.com/users/wxqfree/repos',
    events_url: 'https://api.github.com/users/wxqfree/events{/privacy}',
    received_events_url: 'https://api.github.com/users/wxqfree/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'mainick',
    id: 67373,
    node_id: 'MDQ6VXNlcjY3Mzcz',
    avatar_url: 'https://avatars.githubusercontent.com/u/67373?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/mainick',
    html_url: 'https://github.com/mainick',
    followers_url: 'https://api.github.com/users/mainick/followers',
    following_url:
      'https://api.github.com/users/mainick/following{/other_user}',
    gists_url: 'https://api.github.com/users/mainick/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/mainick/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/mainick/subscriptions',
    organizations_url: 'https://api.github.com/users/mainick/orgs',
    repos_url: 'https://api.github.com/users/mainick/repos',
    events_url: 'https://api.github.com/users/mainick/events{/privacy}',
    received_events_url: 'https://api.github.com/users/mainick/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'esin',
    id: 69767,
    node_id: 'MDQ6VXNlcjY5NzY3',
    avatar_url: 'https://avatars.githubusercontent.com/u/69767?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/esin',
    html_url: 'https://github.com/esin',
    followers_url: 'https://api.github.com/users/esin/followers',
    following_url: 'https://api.github.com/users/esin/following{/other_user}',
    gists_url: 'https://api.github.com/users/esin/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/esin/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/esin/subscriptions',
    organizations_url: 'https://api.github.com/users/esin/orgs',
    repos_url: 'https://api.github.com/users/esin/repos',
    events_url: 'https://api.github.com/users/esin/events{/privacy}',
    received_events_url: 'https://api.github.com/users/esin/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'yxm0513',
    id: 73510,
    node_id: 'MDQ6VXNlcjczNTEw',
    avatar_url: 'https://avatars.githubusercontent.com/u/73510?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/yxm0513',
    html_url: 'https://github.com/yxm0513',
    followers_url: 'https://api.github.com/users/yxm0513/followers',
    following_url:
      'https://api.github.com/users/yxm0513/following{/other_user}',
    gists_url: 'https://api.github.com/users/yxm0513/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/yxm0513/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/yxm0513/subscriptions',
    organizations_url: 'https://api.github.com/users/yxm0513/orgs',
    repos_url: 'https://api.github.com/users/yxm0513/repos',
    events_url: 'https://api.github.com/users/yxm0513/events{/privacy}',
    received_events_url: 'https://api.github.com/users/yxm0513/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'GavinBryan',
    id: 76623,
    node_id: 'MDQ6VXNlcjc2NjIz',
    avatar_url: 'https://avatars.githubusercontent.com/u/76623?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/GavinBryan',
    html_url: 'https://github.com/GavinBryan',
    followers_url: 'https://api.github.com/users/GavinBryan/followers',
    following_url:
      'https://api.github.com/users/GavinBryan/following{/other_user}',
    gists_url: 'https://api.github.com/users/GavinBryan/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/GavinBryan/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/GavinBryan/subscriptions',
    organizations_url: 'https://api.github.com/users/GavinBryan/orgs',
    repos_url: 'https://api.github.com/users/GavinBryan/repos',
    events_url: 'https://api.github.com/users/GavinBryan/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/GavinBryan/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'coder-selvarajan',
    id: 78447,
    node_id: 'MDQ6VXNlcjc4NDQ3',
    avatar_url: 'https://avatars.githubusercontent.com/u/78447?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/coder-selvarajan',
    html_url: 'https://github.com/coder-selvarajan',
    followers_url: 'https://api.github.com/users/coder-selvarajan/followers',
    following_url:
      'https://api.github.com/users/coder-selvarajan/following{/other_user}',
    gists_url: 'https://api.github.com/users/coder-selvarajan/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/coder-selvarajan/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/coder-selvarajan/subscriptions',
    organizations_url: 'https://api.github.com/users/coder-selvarajan/orgs',
    repos_url: 'https://api.github.com/users/coder-selvarajan/repos',
    events_url:
      'https://api.github.com/users/coder-selvarajan/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/coder-selvarajan/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'gogolnr1',
    id: 102792,
    node_id: 'MDQ6VXNlcjEwMjc5Mg==',
    avatar_url: 'https://avatars.githubusercontent.com/u/102792?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/gogolnr1',
    html_url: 'https://github.com/gogolnr1',
    followers_url: 'https://api.github.com/users/gogolnr1/followers',
    following_url:
      'https://api.github.com/users/gogolnr1/following{/other_user}',
    gists_url: 'https://api.github.com/users/gogolnr1/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/gogolnr1/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/gogolnr1/subscriptions',
    organizations_url: 'https://api.github.com/users/gogolnr1/orgs',
    repos_url: 'https://api.github.com/users/gogolnr1/repos',
    events_url: 'https://api.github.com/users/gogolnr1/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/gogolnr1/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'mahdimp',
    id: 106799,
    node_id: 'MDQ6VXNlcjEwNjc5OQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/106799?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/mahdimp',
    html_url: 'https://github.com/mahdimp',
    followers_url: 'https://api.github.com/users/mahdimp/followers',
    following_url:
      'https://api.github.com/users/mahdimp/following{/other_user}',
    gists_url: 'https://api.github.com/users/mahdimp/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/mahdimp/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/mahdimp/subscriptions',
    organizations_url: 'https://api.github.com/users/mahdimp/orgs',
    repos_url: 'https://api.github.com/users/mahdimp/repos',
    events_url: 'https://api.github.com/users/mahdimp/events{/privacy}',
    received_events_url: 'https://api.github.com/users/mahdimp/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'neveo',
    id: 115875,
    node_id: 'MDQ6VXNlcjExNTg3NQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/115875?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/neveo',
    html_url: 'https://github.com/neveo',
    followers_url: 'https://api.github.com/users/neveo/followers',
    following_url: 'https://api.github.com/users/neveo/following{/other_user}',
    gists_url: 'https://api.github.com/users/neveo/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/neveo/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/neveo/subscriptions',
    organizations_url: 'https://api.github.com/users/neveo/orgs',
    repos_url: 'https://api.github.com/users/neveo/repos',
    events_url: 'https://api.github.com/users/neveo/events{/privacy}',
    received_events_url: 'https://api.github.com/users/neveo/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'casjay',
    id: 126880,
    node_id: 'MDQ6VXNlcjEyNjg4MA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/126880?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/casjay',
    html_url: 'https://github.com/casjay',
    followers_url: 'https://api.github.com/users/casjay/followers',
    following_url: 'https://api.github.com/users/casjay/following{/other_user}',
    gists_url: 'https://api.github.com/users/casjay/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/casjay/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/casjay/subscriptions',
    organizations_url: 'https://api.github.com/users/casjay/orgs',
    repos_url: 'https://api.github.com/users/casjay/repos',
    events_url: 'https://api.github.com/users/casjay/events{/privacy}',
    received_events_url: 'https://api.github.com/users/casjay/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'drenovac',
    id: 146121,
    node_id: 'MDQ6VXNlcjE0NjEyMQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/146121?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/drenovac',
    html_url: 'https://github.com/drenovac',
    followers_url: 'https://api.github.com/users/drenovac/followers',
    following_url:
      'https://api.github.com/users/drenovac/following{/other_user}',
    gists_url: 'https://api.github.com/users/drenovac/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/drenovac/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/drenovac/subscriptions',
    organizations_url: 'https://api.github.com/users/drenovac/orgs',
    repos_url: 'https://api.github.com/users/drenovac/repos',
    events_url: 'https://api.github.com/users/drenovac/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/drenovac/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'DigDug101',
    id: 153598,
    node_id: 'MDQ6VXNlcjE1MzU5OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/153598?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/DigDug101',
    html_url: 'https://github.com/DigDug101',
    followers_url: 'https://api.github.com/users/DigDug101/followers',
    following_url:
      'https://api.github.com/users/DigDug101/following{/other_user}',
    gists_url: 'https://api.github.com/users/DigDug101/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/DigDug101/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/DigDug101/subscriptions',
    organizations_url: 'https://api.github.com/users/DigDug101/orgs',
    repos_url: 'https://api.github.com/users/DigDug101/repos',
    events_url: 'https://api.github.com/users/DigDug101/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/DigDug101/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'gaspas',
    id: 168907,
    node_id: 'MDQ6VXNlcjE2ODkwNw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/168907?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/gaspas',
    html_url: 'https://github.com/gaspas',
    followers_url: 'https://api.github.com/users/gaspas/followers',
    following_url: 'https://api.github.com/users/gaspas/following{/other_user}',
    gists_url: 'https://api.github.com/users/gaspas/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/gaspas/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/gaspas/subscriptions',
    organizations_url: 'https://api.github.com/users/gaspas/orgs',
    repos_url: 'https://api.github.com/users/gaspas/repos',
    events_url: 'https://api.github.com/users/gaspas/events{/privacy}',
    received_events_url: 'https://api.github.com/users/gaspas/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'jazziejoy',
    id: 173430,
    node_id: 'MDQ6VXNlcjE3MzQzMA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/173430?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/jazziejoy',
    html_url: 'https://github.com/jazziejoy',
    followers_url: 'https://api.github.com/users/jazziejoy/followers',
    following_url:
      'https://api.github.com/users/jazziejoy/following{/other_user}',
    gists_url: 'https://api.github.com/users/jazziejoy/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/jazziejoy/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/jazziejoy/subscriptions',
    organizations_url: 'https://api.github.com/users/jazziejoy/orgs',
    repos_url: 'https://api.github.com/users/jazziejoy/repos',
    events_url: 'https://api.github.com/users/jazziejoy/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/jazziejoy/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'artlantis',
    id: 188478,
    node_id: 'MDQ6VXNlcjE4ODQ3OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/188478?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/artlantis',
    html_url: 'https://github.com/artlantis',
    followers_url: 'https://api.github.com/users/artlantis/followers',
    following_url:
      'https://api.github.com/users/artlantis/following{/other_user}',
    gists_url: 'https://api.github.com/users/artlantis/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/artlantis/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/artlantis/subscriptions',
    organizations_url: 'https://api.github.com/users/artlantis/orgs',
    repos_url: 'https://api.github.com/users/artlantis/repos',
    events_url: 'https://api.github.com/users/artlantis/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/artlantis/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'manishnakar',
    id: 190051,
    node_id: 'MDQ6VXNlcjE5MDA1MQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/190051?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/manishnakar',
    html_url: 'https://github.com/manishnakar',
    followers_url: 'https://api.github.com/users/manishnakar/followers',
    following_url:
      'https://api.github.com/users/manishnakar/following{/other_user}',
    gists_url: 'https://api.github.com/users/manishnakar/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/manishnakar/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/manishnakar/subscriptions',
    organizations_url: 'https://api.github.com/users/manishnakar/orgs',
    repos_url: 'https://api.github.com/users/manishnakar/repos',
    events_url: 'https://api.github.com/users/manishnakar/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/manishnakar/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'chrischandler',
    id: 193224,
    node_id: 'MDQ6VXNlcjE5MzIyNA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/193224?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/chrischandler',
    html_url: 'https://github.com/chrischandler',
    followers_url: 'https://api.github.com/users/chrischandler/followers',
    following_url:
      'https://api.github.com/users/chrischandler/following{/other_user}',
    gists_url: 'https://api.github.com/users/chrischandler/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/chrischandler/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/chrischandler/subscriptions',
    organizations_url: 'https://api.github.com/users/chrischandler/orgs',
    repos_url: 'https://api.github.com/users/chrischandler/repos',
    events_url: 'https://api.github.com/users/chrischandler/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/chrischandler/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'manish700',
    id: 211528,
    node_id: 'MDQ6VXNlcjIxMTUyOA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/211528?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/manish700',
    html_url: 'https://github.com/manish700',
    followers_url: 'https://api.github.com/users/manish700/followers',
    following_url:
      'https://api.github.com/users/manish700/following{/other_user}',
    gists_url: 'https://api.github.com/users/manish700/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/manish700/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/manish700/subscriptions',
    organizations_url: 'https://api.github.com/users/manish700/orgs',
    repos_url: 'https://api.github.com/users/manish700/repos',
    events_url: 'https://api.github.com/users/manish700/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/manish700/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'ClaytonDewey',
    id: 226353,
    node_id: 'MDQ6VXNlcjIyNjM1Mw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/226353?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/ClaytonDewey',
    html_url: 'https://github.com/ClaytonDewey',
    followers_url: 'https://api.github.com/users/ClaytonDewey/followers',
    following_url:
      'https://api.github.com/users/ClaytonDewey/following{/other_user}',
    gists_url: 'https://api.github.com/users/ClaytonDewey/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/ClaytonDewey/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/ClaytonDewey/subscriptions',
    organizations_url: 'https://api.github.com/users/ClaytonDewey/orgs',
    repos_url: 'https://api.github.com/users/ClaytonDewey/repos',
    events_url: 'https://api.github.com/users/ClaytonDewey/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/ClaytonDewey/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'mhaidarhanif',
    id: 235584,
    node_id: 'MDQ6VXNlcjIzNTU4NA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/235584?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/mhaidarhanif',
    html_url: 'https://github.com/mhaidarhanif',
    followers_url: 'https://api.github.com/users/mhaidarhanif/followers',
    following_url:
      'https://api.github.com/users/mhaidarhanif/following{/other_user}',
    gists_url: 'https://api.github.com/users/mhaidarhanif/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/mhaidarhanif/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/mhaidarhanif/subscriptions',
    organizations_url: 'https://api.github.com/users/mhaidarhanif/orgs',
    repos_url: 'https://api.github.com/users/mhaidarhanif/repos',
    events_url: 'https://api.github.com/users/mhaidarhanif/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/mhaidarhanif/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'wymna',
    id: 237820,
    node_id: 'MDQ6VXNlcjIzNzgyMA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/237820?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/wymna',
    html_url: 'https://github.com/wymna',
    followers_url: 'https://api.github.com/users/wymna/followers',
    following_url: 'https://api.github.com/users/wymna/following{/other_user}',
    gists_url: 'https://api.github.com/users/wymna/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/wymna/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/wymna/subscriptions',
    organizations_url: 'https://api.github.com/users/wymna/orgs',
    repos_url: 'https://api.github.com/users/wymna/repos',
    events_url: 'https://api.github.com/users/wymna/events{/privacy}',
    received_events_url: 'https://api.github.com/users/wymna/received_events',
    type: 'User',
    site_admin: false,
  },
];

export default mockFollowers